// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { messageFormat } from '@clubmed/utils';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { Multimedia } from 'Components/widgets/multimedia/Multimedia';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

type PhotoMedia = { url: string };
type VideoMedia = { url: string, thumbnailUrl: string };

type Props = {
  config: CMSContent,
  id: string,
  media: {
    photos: Array<PhotoMedia>,
    videos: Array<VideoMedia>,
    videos360: Array<VideoMedia>,
  },
  resort: ?Resort,
  socialPictures: Array<SocialPicture>,
  title: string,
};

export const ProductMultimediaLine = ({
  config,
  id,
  media = {},
  resort = {},
  socialPictures,
  title,
}: Props) => {
  const { photos, videos, videos360 } = media;

  if (isEmpty(photos) && isEmpty(videos) && isEmpty(videos360) && isEmpty(socialPictures)) {
    return null;
  }

  const productGalleryLabel = config.common.galleries.productGallery;
  const productName = resort && resort.name;
  const galleryLabel = config.common.galleries.gallery;

  return (
    <SiteContainer className="Line" id={id}>
      <LineTitle>{title}</LineTitle>
      <Multimedia
        closeLabel={config.common.close}
        galleryLabel={
          productName && productGalleryLabel
            ? messageFormat(productGalleryLabel).format({ productName })
            : galleryLabel
        }
        labels={{
          photos: config.common.photoTitle,
          socialPictures: config.common.socialPicturesTitle,
          videos: config.common.videoTitle,
          videos360: config.common.video360Title,
        }}
        medias={{ ...media, socialPictures }}
        nextLabel={config.common.next}
        previousLabel={config.common.previous}
      />
    </SiteContainer>
  );
};
